import { gql, useMutation } from '@apollo/client';
import { IconButton, useDisclosure, useToast } from '@chakra-ui/react';
import * as React from 'react';

import { logError } from '@/imports/logging/ClientLogger';
import { DownloadIcon } from '@/imports/ui/chakra/feather';

import {
  UserSearchExportButton_ExportUserSearch,
  UserSearchExportButton_ExportUserSearchVariables,
} from './graphql-types/UserSearchExportButton_ExportUserSearch';

import { IUseMembersPagination } from '../../hooks/useMembersPagination/useMembersPagination';
import { queryStateToFilter } from '../../usersQueryState';
import { SuccessModal } from './components/SuccessModal/SuccessModal';

const USER_SEARCH_EXPORT = gql`
  mutation UserSearchExportButton_ExportUserSearch(
    $input: ExportUserSearchInput!
  ) {
    exportUserSearch(input: $input) {
      result
    }
  }
`;

type IUserSearchExportButton = Pick<
  IUseMembersPagination,
  'queryState' | 'archivedOnly'
>;

export const UserSearchExportButton: React.FC<IUserSearchExportButton> = (
  props
) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const { queryState, archivedOnly } = props;

  const [exportUserSearch] = useMutation<
    UserSearchExportButton_ExportUserSearch,
    UserSearchExportButton_ExportUserSearchVariables
  >(USER_SEARCH_EXPORT);

  const onClick = async (): Promise<void> => {
    try {
      await exportUserSearch({
        variables: {
          input: {
            filter: queryStateToFilter(queryState, { archivedOnly }),
          },
        },
      });
      onOpen();
    } catch (err) {
      toast({ title: 'Failed to start user search export ', status: 'error' });
      logError(err);
    }
  };
  return (
    <>
      <IconButton
        colorScheme="primary"
        variant="outline"
        aria-label="download"
        borderColor="primary.500"
        icon={<DownloadIcon color="primary.500" boxSize={5}/>}
        onClick={onClick}
      />
      <SuccessModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};
